

    require('./lines/LinesSeries');
    require('./lines/LinesView');

    var echarts = require('../echarts');
    echarts.registerLayout(
        require('./lines/linesLayout')
    );



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/chart/lines.js
// module id = 191
// module chunks = 1